var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"region-name",class:[_vm.active && 'active'],attrs:{"to":("/maps/region/" + (_vm.region.slug))},on:{"click":function (e) { return _vm.$emit('click', e); }}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }